import React from 'react'
import { default as MButton } from '@material-ui/core/Button'

import { withStyles } from '@material-ui/core/styles'

const styles = theme => ({
  root: {
    textTransform: 'none'
  },
});

const Button = ({ classes, theme, style, color, children, ...props }) => {

  let btnStyle = {}
  let btnVariant = 'contained'
  let btnSize = 'large'
  let btnColor = 'primary'

  if (style) {
    if (style.includes("small"))
      btnSize = 'small'
    else if (style.includes('large') || style.includes('big'))
      btnSize = "large"

    if (style.includes('outline'))
      btnVariant = 'outlined'
    else if (style.includes('text'))
      btnVariant = 'text'
  }  

  return (
    <MButton style={btnStyle} variant={btnVariant} color={btnColor} size={btnSize} className={classes.btnStyle}
      { ...props }>
      { children }
    </MButton>
  )
}

export default withStyles(styles, { withTheme: true })(Button)

